import {format} from 'date-fns';

import analytics from 'analytics.js';
import ClipboardJS from 'libraries/clipboard.js';
import events from 'events.js';
import http from 'http.js';

function trackSheetOpen(factsheet, searchQuery, user, network) {
    const data = {
        userName: user.name,
        userId: user.id,
        userType: user.userType,
        clinicalSoftware: user.practiceSoftware,
        userPostCode: user.postCode,
        source: 'healthshare',
        sponsor: factsheet.sponsor,
        id: factsheet.id,
        name: factsheet.name,
        searchQuery,
        network,
    };
    analytics.track('openSheet', data);
}

function trackSheetEmail(factsheet, user, network) {
    const data = {
        userName: user.name,
        userId: user.id,
        userType: user.userType,
        clinicalSoftware: user.practiceSoftware,
        userPostCode: user.postCode,
        source: 'healthshare',
        sponsor: factsheet.sponsor,
        id: factsheet.id,
        name: factsheet.name,
        network,
    };
    analytics.track('emailSheet', data);
}

function toggleFavourited(button, isMyHealthshare) {
    if (isMyHealthshare) {
        button.classList.toggle('undo');
    } else {
        button.classList.toggle('delete');
    }
    button.querySelector('i').classList.toggle('fa-star-o');
    button.querySelector('i').classList.toggle('fa-star');
}

function favouriteAction(button) {
    button.removeAttribute('disabled');
    toggleFavourited(button, false);
    button.getElementsByClassName('favourite')[0].innerHTML =
        'Remove from Favourites';
}

function deleteFavouriteAction(button) {
    button.removeAttribute('disabled');
    toggleFavourited(button, false);
    button.getElementsByClassName('favourite')[0].innerHTML =
        'Add to Favourites';
}

async function favourite(callback, button) {
    const favourite = button;
    const factsheetId = favourite.dataset.factsheetId;
    favourite.setAttribute('disabled', 'disabled');
    try {
        await http.post({
            url: '/api/factsheets/v1/favourites/',
            data: {
                factsheet: factsheetId,
            },
        });
        callback(favourite);
    } catch (ex) {
        favourite.removeAttribute('disabled');
    }
}

async function deleteFavourite(callback, button) {
    const deleteFavourite = button;
    const factsheetId = deleteFavourite.dataset.factsheetId;
    deleteFavourite.setAttribute('disabled', 'disabled');
    try {
        await http.delete({
            url: `/api/factsheets/v1/factsheets/${factsheetId}/favourite/`,
        });
        callback(deleteFavourite);
    } catch (ex) {
        deleteFavourite.removeAttribute('disabled');
    }

    try {
        await http.delete({
            url: `/api/factsheets/v1/factsheets/${factsheetId}/favourite/`,
        });
        callback(deleteFavourite);
    } catch (ex) {
        deleteFavourite.removeAttribute('disabled');
    }
}

function copySuccess(elem, clipboardClass, messageClass) {
    const fa = elem.getElementsByClassName('fa')[0];
    fa.classList.remove('fa-copy');
    fa.classList.add('fa-check');
    const span = elem.querySelector('span');
    span.textContent = 'Copied';
    elem.setAttribute('disabled', 'disabled');
    const clipboard = document.querySelector(clipboardClass);
    const text = elem.getAttribute('data-clipboard-text');
    clipboard.textContent = text.replace(/\n/g, '\r\n');
    clipboard.style.display = 'block';
    setTimeout(clipboard.select.bind(clipboard));
    const message = document.querySelector(messageClass);
    message.textContent = 'Information has been copied to your clipboard';
}

function clientCopy(elem) {
    const text = elem.dataset.clipboardText;
    return text.replace(/\n/g, '\r\n');
}

function clientError(event, clipboardClass, messageClass) {
    const elem = event.trigger;
    const clipboard = document.querySelector(clipboardClass);
    const text = elem.dataset.clipboardText;
    clipboard.textContent = text.replace(/\n/g, '\r\n');
    clipboard.style.display = 'block';
    clipboard.select();
    document.querySelector(messageClass).style.display = 'none';
}

(async function() {
    await events.ready();

    // Track open
    const dataset = document.body.dataset;
    if (!dataset.clinicalSoftware) {
        const factsheet = JSON.parse(dataset.factsheetTrack);
        const requestQuery = dataset.requestQuery;
        const user = JSON.parse(dataset.userTrack);
        const network = dataset.network;
        trackSheetOpen(factsheet, requestQuery, user, network);
    }

    // Handle favourites
    const favouriteElem = document.getElementById('favourite');
    if (favouriteElem) {
        events.listen(favouriteElem, 'click', function() {
            if (favouriteElem.classList.contains('delete')) {
                deleteFavourite(deleteFavouriteAction, favouriteElem);
            } else {
                favourite(favouriteAction, favouriteElem);
            }
        });
    }

    // Toggle show / hide more factsheets in sidebar
    const searchMore = document.querySelector('.search-more a');
    if (searchMore) {
        events.listen(searchMore, 'click', function() {
            const moreFactsheets = document.getElementById('moreFactsheets');
            let txt = 'See More Fact Sheets';
            const height = moreFactsheets.style.height;
            if (!height || height === '0px') {
                txt = 'See Fewer Fact Sheets';
            }
            searchMore.innerText = txt;
        });
    }

    // Handle copy to clipboard
    const printClient = new ClipboardJS('.copy-text.print', {
        text: clientCopy,
    });

    printClient.on('success', function(event) {
        copySuccess(
            event.trigger,
            '.clipboard-text.print',
            '.message-text.print',
        );
    });

    printClient.on('error', function(errorEvent) {
        clientError(
            errorEvent,
            '.clipboard-text.print',
            '.message-text.print',
        );
    });

    const emailClient = new ClipboardJS('.copy-text.email', {
        text: clientCopy,
    });

    emailClient.on('error', function(errorEvent) {
        clientError(
            errorEvent,
            '.clipboard-text.email',
            '.message-text.email',
        );
    });

    emailClient.on('success', function(event) {
        copySuccess(
            event.trigger,
            '.clipboard-text.email',
            '.message-text.email',
        );
    });

    if (navigator.userAgent.indexOf('Trident') !== -1) {
        const langs = Array.from(document.getElementsByClassName('languages'));
        for (const lang of langs) {
            lang.classList.append('dropup');
        }
        const row = document.querySelector('.modal-body > .row');
        if (row) {
            row.classList.remove('margin-sm');
        }
    }

    const backButton = document.getElementById('back-button');
    if (backButton) {
        events.listen(backButton, 'click', function(evt) {
            evt.preventDefault();
            window.history.back();
        });
    }

    const sendEmail = Array.from(
        document.getElementsByClassName('send-email'),
    );
    for (const elem of sendEmail) {
        events.listen(elem, 'click', async function() {
            const parent = elem.closest('.form-group');
            const emailField = parent.getElementsByClassName('email-field')[0];
            const email = emailField.value;
            const fsId = emailField.dataset.factsheetid;
            const fsName = emailField.dataset.factsheetname;
            const name = emailField.dataset.userid;
            const successText = `HealthShare sent the ${fsName} fact sheet to
                ${email} on ${format(new Date(), 'do MMM, yyyy HH:mm')}`;
            elem.setAttribute('disabled', 'disabled');
            try {
                const resp = await http.post({
                    url: `/api/factsheets/v1/factsheets/${fsId}/email/`,
                    data: {
                        email,
                        practice_info: name,
                    },
                });
                elem.removeAttribute('disabled');
                if (resp.status === 400) {
                    const msgText = parent.getElementsByClassName(
                        'message-text',
                    )[0];
                    msgText.innerText = 'Please enter a valid email address.';
                    parent.classList.add('has-error');
                } else {
                    const msgTextEmail = parent.querySelector(
                        '.message-text.email',
                    );
                    msgTextEmail.innerText = successText;
                    parent.classList.remove('has-error');
                    parent.classList.add('has-success');
                    const elem = document.querySelector('.copy-text.email');
                    elem.classList.remove('hidden');
                    elem.dataset.clipboardText = successText;
                    trackSheetEmail(
                        JSON.parse(document.body.dataset.factsheetTrack),
                        JSON.parse(document.body.dataset.userTrack),
                        document.body.dataset.network,
                    );
                }
            } catch (ex) {
                elem.removeAttribute('disabled');
                const msgText = parent.getElementsByClassName(
                    'message-text',
                )[0];
                msgText.innerText = 'An error occurred. Email not sent.';
                parent.classList.add('has-error');
            }
        });
    }
})();
